import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ConservazioneCaricaDocumentoLibroGiornaleStep2Component } from './conservazione-carica-documento-libro-giornale-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-libro-giornale-step2', {
            url: '/conservazione-carica-libro-giornale',
            ncyBreadcrumb: {
                label: 'Carica Libri Giornale',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-libro-giornale-step2 flex="100"></conservazione-carica-documento-libro-giornale-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoLibroGiornaleStep2Module: string = ng
    .module('conservazione-carica-documento-libro-giornale-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoLibroGiornaleStep2', ConservazioneCaricaDocumentoLibroGiornaleStep2Component)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-libro-giornale-step2/conservazione-carica-documento-libro-giornale-step2.module.ts